export const THEME_STORAGE_KEY = 'nur.theme';

const DEFAULT_THEME = 'dark';
const supportedThemes = new Set(['dark', 'light']);

function normalizeTheme(value) {
  return supportedThemes.has(value) ? value : DEFAULT_THEME;
}

function storedTheme() {
  try {
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return DEFAULT_THEME;
  }
}

function updateThemeColor(theme) {
  document.querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', theme === 'dark' ? '#050b12' : '#eef3f7');
}

export function getTheme() {
  return normalizeTheme(document.documentElement.dataset.theme || storedTheme());
}

export function applyTheme(value, { persist = true } = {}) {
  const theme = normalizeTheme(value);
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  updateThemeColor(theme);

  if (persist) {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
      // The visual theme still works when storage is unavailable.
    }
  }

  window.dispatchEvent(new CustomEvent('nur:theme-change', { detail: { theme } }));
  return theme;
}

export function initializeTheme() {
  return applyTheme(storedTheme(), { persist: false });
}
